import { For, Resource, Show, Suspense } from "solid-js";

import { type S3FilesType } from "~/lib/types";
import { formatFileSize, getFileName, getFileType } from "~/lib/fileUploads";
import { UploadManager } from "~/components/FullScreenUpload";

export const S3Files = ( props: { prefix: string, s3Objects: Resource<S3FilesType | undefined>, allowUpload: boolean, refetchS3Path: () => void } ) => {
	let uploadMgr: { triggerPicker: () => void } | undefined;

	return (
		<div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
			<Suspense fallback={<div>Loading…</div>}>
				<Show when={props.s3Objects.latest}>
					<For each={props.s3Objects.latest?.files}>
						{( file ) => (
							<a href={`/api/download?key=${encodeURIComponent( file.key as string )}`} target="_blank" class="flex flex-col items-center justify-center p-4 border rounded border-gray-300 hover:bg-gray-50 cursor-pointer">
								<img
									src={`/images/icon-${getFileType( file.key as string )?.substring( 0, 3 ) ?? "unknown"}.svg`}
									class="h-8 w-8 mb-1"
									alt={getFileType( file.key as string ) ?? "Unknown File Type"}
								/>
								<span class="text-xs truncate w-full text-center">
									{getFileName( file.key as string )}
								</span>
								<span class="text-[10px] text-gray-500">
									{formatFileSize( file.size as number )}
								</span>
							</a>
						)}
					</For>

					<Show when={props.prefix.includes( "shared" ) && !props.s3Objects.latest?.files}>
						No files found.
					</Show>
				</Show>
			</Suspense>


			<Show when={props.allowUpload}>
				<div
					onClick={() => uploadMgr?.triggerPicker()}
					class="flex flex-col items-center justify-center p-4 border-2 border-dashed border-gray-300 rounded cursor-pointer hover:border-accent">
					<img src="/images/icon-plus.svg" class="w-8" alt="Upload Files" /><span>Upload Files</span>
				</div>

				<UploadManager ref={( el: { triggerPicker: () => void } ) => uploadMgr = el} path={props.prefix} onComplete={() => props.refetchS3Path()} />
			</Show>
		</div> )
};